import { WellTypeBase } from './base/well-type-base';

export class WellType extends WellTypeBase { }